
import React from 'react';

const LocationsInfoSection: React.FC = () => {
  const locations = [
    {
      name: 'IDS佐賀教習所',
      badge: 'DJI推薦修理センター認定',
      company: '株式会社アイテム',
      address: '佐賀県多久市北多久町大字小侍4771',
      phone: '0952-71-9855',
      hours: '平日 9:00〜18:00',
      services: [
        '無償判定・無償修理',
        '他社購入機の無償修理',
        '年次点検',
        '緊急修理',
        '飛行データ解析'
      ]
    },
    {
      name: 'IDS川副教習所',
      badge: 'DJI認定整備士在籍',
      company: '九三エンジニアリング株式会社',
      address: '佐賀県佐賀市川副町小々森146-1',
      phone: '0952-97-5291',
      hours: '平日 9:00〜18:00',
      services: [
        '年次点検',
        '緊急修理',
        '有償修理',
        '部品交換'
      ]
    },
    {
      name: 'IDS鹿児島教習所',
      badge: 'DJI認定整備士在籍',
      company: '株式会社エコナーセリー',
      address: '鹿児島県日置市伊集院町古城795',
      phone: '099-213-9466',
      hours: '平日 9:00〜18:00',
      services: [
        '年次点検',
        '緊急修理',
        '有償修理',
        '部品交換'
      ]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            点検・整備サービス対応拠点
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
            九州各地の3拠点で、お客様の農業ドローンの点検・整備サービスを提供しています。各拠点にDJI認定整備士が在籍し、確実なメンテナンスを行います。
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {locations.map((location, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300 border border-gray-100"
            >
              <div className="mb-6">
                <div className="inline-block bg-blue-600 text-white text-xs font-bold px-4 py-2 rounded-full mb-4">
                  {location.badge}
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {location.name}
                </h3>
                <p className="text-gray-600 font-medium mb-4">{location.company}</p>
              </div>

              <div className="space-y-4 mb-6">
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-blue-600 text-xl"></i>
                  </div>
                  <p className="text-gray-700 ml-3 text-sm leading-relaxed">
                    {location.address}
                  </p>
                </div>

                <div className="flex items-center">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-blue-600 text-xl"></i>
                  </div>
                  <a
                    href={`tel:${location.phone}`}
                    className="text-gray-900 font-bold ml-3 hover:text-blue-600 transition-colors cursor-pointer"
                  >
                    {location.phone}
                  </a>
                </div>

                <div className="flex items-center">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-blue-600 text-xl"></i>
                  </div>
                  <p className="text-gray-700 ml-3 text-sm">{location.hours}</p>
                </div>
              </div>

              <div className="mb-6">
                <h4 className="font-bold text-gray-900 mb-3 text-sm">対応サービス：</h4>
                <ul className="space-y-2">
                  {location.services.map((service, idx) => (
                    <li key={idx} className="flex items-start">
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-green-600 text-lg"></i>
                      </div>
                      <span className="text-gray-700 ml-2 text-sm">{service}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LocationsInfoSection;
